import React from 'react';
import { Box } from '@mui/material';
import Sidebar from '../landingPage/Sidebar';
import WorkspaceContent from './WorkspaceContent';

const SidebarLayout = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        bgcolor: '#fafbfd',
      }}
    >
      <Sidebar />
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: '#fafbfd',
          overflow: 'auto',
        }}
      >
        <WorkspaceContent />
      </Box>
    </Box>
  );
};

export default SidebarLayout;
